import React, { Component } from 'react'
import '../../sass/_button.scss';
import Link from 'next/link';

export default class index extends Component {
    render() {
        return (
            this.props.route == undefined ?
                <div className={this.props.extra ? "primary-home-btn pl-0 pr-0 test-btn-s" : "main-btn pl-0 pr-0 test-btn-s"}>
                    <div className="svg-wrapper">
                        <svg height="48" width="200" xmlns="http://www.w3.org/2000/svg">
                            <rect className="shape" height="38" width="200" />
                        </svg>
                        <div className="text">{this.props.name}</div>
                    </div>
                </div> :
                <Link href={"/" + this.props.route} as={"/" + this.props.route} >
                    <div className={this.props.extra ? "primary-home-btn pl-0 pr-0 test-btn-s" : "main-btn pl-0 pr-0 test-btn-s"}>
                        <div className="svg-wrapper">
                            <svg height="48" width="200" xmlns="http://www.w3.org/2000/svg">
                                <rect className="shape" height="38" width="200" />
                            </svg>
                            <div className="text">{this.props.name}</div>
                        </div>
                    </div>
                </Link>
        )
    }
}
